import { KEY } from 'store/booking/types';

/**
 * We are using /booking/specialtiesV2 for app version 5.7.0 so booking data
 * will be backwards compatibile for versions 5.6 and earlier.
 */
export const GET_SPECIALTIES = `${KEY}.GET_SPECIALTIES`;
export const GET_SPECIALTIES_SUCCESS = `${KEY}.GET_SPECIALTIES_SUCCESS`;
export const GET_SPECIALTIES_FAIL = `${KEY}.GET_SPECIALTIES_FAIL`;

export const getSpecialties = () => ({
  type: GET_SPECIALTIES,
  payload: {
    client: 'scheduling',
    request: {
      url: '/specialties'
    }
  }
});
